import $ from 'jquery'
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { closeModal } from '@/function/function.js';

extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
  });

export default {
    name: 'prendre-constante',
    components: {
        ValidationProvider,
        ValidationObserver,
    },

    props: {
        consultation: Object
    },

    data () {
        return {
            loading: false,
            constantes:{
                temperature:  '',
                tension_arterielle:  '',
                poids:  '',
                poids_unit: 'g',
                taille:  '',
                taille_unit: 'm',
                pouls:  '',
                bras_gauche_ta: '',
                bras_gauche_unit: 'cmHg',
                bras_droit_ta: '',
                bras_droit_unit: 'cmHg',
                v_model_o: [],
            },

            additional_loading: true,
            additional_empty: false,

            filtered_occurence: [],
            // v_model_o: [],
            o_occurence: [],
            selected_champ: [],
            btn_disable: false,
            save_loading: false,
            has_content: false
            
        }
    },

    computed: {
        champs_exm_clinique() {
            return this.$store.getters["champs_exm_clinique"];
        },

        liste_occurences() {
            return this.$store.getters["liste_occurences"];
        },
    },

    mounted () {
        if (this.consultation) {
            let type_consultation_id = this.consultation.tarif_consultation.type_consultation.id
            this.refreshChampExamenClinique(type_consultation_id)
        }
        
    },

    methods: {
        async refreshChampExamenClinique(type_consultation_id) {
            this.$store.dispatch("getChampExamClinique", 
                { 
                    data_type: 'examen_clinique', consultation_id: this.consultation.id, 
                    en_cours: true, type_consultation_id: type_consultation_id }
            ).then(async() => {
                console.log(">>> ", this.champs_exm_clinique)
                if (this.champs_exm_clinique.length > 0) {
                    this.additional_empty = false
                } else {
                    this.additional_empty = true
                }

                this.additional_loading = false

                await this.champs_exm_clinique.forEach(el => {
                    let contenu = ''
                    let contents = []

                    if (el.contenu.length > 0) {
                        if (el.type_champ != 'Choix multiple') {
                            contenu = el.contenu[0].occurence
                            this.has_content = true
                        } else {
                            contenu = el.contenu
                            contents = contenu
                        }
                    } else {
                        contenu = []
                        contents = []
                    }
                    
                    this.constantes.v_model_o.push({ valeur: contenu, attribut: el.champ_id })
                    this.selected_champ.push({ selected_champ_occurences: contents })
                    this.o_occurence.push('')
                })
            })
        },

        clearAll(index, selector) {
            
            $('#'+selector).val('')
            if (index == '1') {
                this.constantes.taille = ''
            } else if (index == '2') {
                console.log("s: ",selector)
                this.constantes.temperature = ''
            } else if (index == '3') {
                this.constantes.tension_arterielle = ''
            }
        },

        prendreConstante: function(){
            this.loading = true;
            this.$refs.form.validate().then((success) => {
                if (!success) {
                    this.loading = false;
                    return;
                }
                
            });
            this.$store.dispatch('putConstante',{
                id: this.consultation.id,
                data: this.constantes
            }).then(
                () =>{
                    this.loading = false;
                    this.constantes.temperature = null,
                    this.constantes.tension_arterielle = null,
                    this.constantes.poids = null,
                    this.constantes.taille = null,
                    this.constantes.pouls = null,
                    this.constantes.bras_gauche_ta = null,
                    this.constantes.bras_droit_ta = null,
                

                    $('.modal').modal('hide');
                    this.successPriseConstante()
                })
        },
        successPriseConstante: function(){
            this.$toasted.show('Les constantes du patient ont été enregistrées',{
                duration: 3000,
                action:[
                {
                    text:'X',
                    onClick:(e,toastObject)=>{
                    toastObject.goAway(0);
                    }
                }
                ],
                theme:'toasted-primary',
                type:'success',
                position:'top-center'
             
            })
        },
        /**
         * Ajoute le caractère slash (/) après n chiffres
         * @param {*} n 
         * @param {} selector (est l'ID du champ input)
         */
        // async formatNumberToSlash(n, selector) {
        //     let nb_car = $('#'+selector).val().length;
        //     if (n == '1') {
        //         $('#'+selector).val( $('#'+selector).val().replace(/[^0-9m ]+/g, '') )

        //         if(nb_car == n) {
        //             $('#'+selector).val($('#'+selector).val()+'m ');
        //         }
        //     } else {
        //         $('#'+selector).val( $('#'+selector).val().replace(/[^0-9/]+/g, '') )

        //         if(nb_car == n) {
        //             $('#'+selector).val($('#'+selector).val()+'/');
        //         }
        //     }
            
        // },

        /**
         * Ajoute le caractère slash (/) après n chiffres
         * @param {*} n 
         * @param {} selector (est l'ID du champ input)
         */
        async formatNumberToSlash(n, selector) {
            let nb_car = $('#' + selector).val().length;
            if (n == '1') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9m ]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + 'm ');
                }
            } else if (n == '2') {
                console.log("ICIII")
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9^C°]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + '°');
                }else if (nb_car == 4) {
                    $('#' + selector).val($('#' + selector).val() + 'C');
                }
                this.constantes.temperature = $('#' + selector).val()
            }  else if (n == '3') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9/]+/g, ''))

                if (nb_car == 2) {
                    $('#' + selector).val($('#' + selector).val() + '/');
                }
            }
        },

        async onlyDigitSlash(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,/]+/g, ''))
        },

        async formatComma(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,.]+/g, ''))
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) 
        {
            $('#'+selector).val( $('#'+selector).val().replace(/[^0-9]+/g, '') )
        },

        /**
         * Submit form
         */
        async onSubmit() 
        {
            console.log("Constante prise");
            this.loading = true;
            this.$refs.form.validate().then((success) => {
                if (!success) {
                    this.loading = false;
                    return;
                }

                setTimeout(() => {
                    this.$refs.form.reset();
                    this.$refs.close_modal.click();

                    this.loading = false;
                }, 1000);
                
            });
            setTimeout(() => {
                $('.modal').modal('hide');

                this.loading = false;
            }, 1000);
        }, 

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        }
    }
}


